const heavyTrucks = [{
  cName: 'HEAVY TRUCKS OR TRUCK-TRACTORS by owner declared Gross Vehicle Weight',
  oSubMenu: [{
    cName: '41 Truck / Truck-Tractor 5001 to 5999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 5001 to 5999 lbs GVW|5.06|10.13|15.19|20.25|25.31|30.38|35.44|40.50|45.56|50.63|55.69|60.75|65.81|70.88|75.94|1|72.35|60.75|2|3| |41',
  }, // FS320.08(4)a
  {
    cName: '41 Truck / Truck-Tractor 6000 to 7999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 6000 to 7999 lbs GVW|7.31|14.63|21.94|29.25|36.56|43.88|51.19|58.50|65.81|73.13|80.44|87.75|95.06|102.38|109.69|1|99.35|87.75|2|3| |41',
  }, // FS320.08(4)b
  {
    cName: '41 Truck / Truck-Tractor 8000 to 9999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 8000 to 9999 lbs GVW|8.58|17.17|25.75|34.33|42.92|51.50|60.08|68.67|77.25|85.83|94.92|103.00|111.58|120.17|128.75|1|2|103.00|2|1| |41',
  }, // FS320.08(4)c
  {
    cName: '41 Truck / Truck-Tractor 10,000 to 14,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 10,000 to 14,999 lbs GVW|9.83|19.67|29.50|39.33|49.17|59.00|68.83|78.67|88.50|98.33|108.17|118.00|127.83|137.67|147.50|1|2|118.00|2|1| |410',
  }, // FS320.08(4)d
  {
    cName: '41 Truck / Truck-Tractor 15,000 to 19,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 15,000 to 19,999 lbs GVW|14.75|29.50|44.25|59.00|73.75|88.50|103.25|118.00|132.75|147.50|162.25|177.00|191.75|206.50|221.25|1|2|177.00|2|1| |410',
  }, // FS320.08(4)e
  {
    cName: '41 Truck / Truck-Tractor 20,000 to 26,000 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 20,000 to 26,000 lbs GVW|20.92|41.83|62.75|83.67|104.58|125.50|146.42|167.33|188.25|209.17|230.08|251.00|271.92|292.83|313.75|1|2|251.00|2|1| |410',
  }, // FS320.08(4)f
  {
    cName: '41 Truck / Truck-Tractor 26,001 to 34,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 26,001 to 34,999 lbs GVW|27.00|54.00|81.00|108.00|135.00|162.00|189.00|216.00|243.00|270.00|297.00|324.00|351.00|378.00|405.00|1|2|324.00|2|2| |410',
  }, // FS320.08(4)g
  {
    cName: '41 Truck / Truck-Tractor 35,000 to 43,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 35,000 to 43,999 lbs GVW|33.75|67.50|101.25|135.00|168.75|202.50|236.25|270.00|303.75|337.50|371.25|405.00|438.75|472.50|506.25|1|2|405.00|2|2| |410',
  }, // FS320.08(4)h
  {
    cName: '41 Truck / Truck-Tractor 44,000 to 54,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 44,000 to 54,999 lbs GVW|64.42|128.83|193.25|257.67|322.08|386.50|450.92|515.33|579.75|644.17|708.58|773.00|837.42|901.83|966.25|1|2|773.00|2|2| |410',
  }, // FS320.08(4)i
  {
    cName: '41 Truck / Truck-Tractor 55,000 to 61,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 55,000 to 61,999 lbs GVW|76.33|152.67|229.00|305.33|381.67|458.00|534.33|610.67|687.00|763.33|839.67|916.00|992.33|1068.67|1145.00|1|2|916.00|2|2| |410',
  }, // FS320.08(4)j
  {
    cName: '41 Truck / Truck-Tractor 62,000 to 71,999 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 62,000 to 71,999 lbs GVW|90.00|180.00|270.00|360.00|450.00|540.00|630.00|720.00|810.00|900.00|990.00|1080.00|1170.00|1260.00|1350.00|1|2|1080.00|2|2| |410',
  }, // FS320.08(4)k
  {
    cName: '41 Truck / Truck-Tractor 72,000 to 80,000 lbs GVW',
    cReturn: '41 Truck / Truck-Tractor 72,000 to 80,000 lbs GVW|110.17|220.33|330.50|440.67|550.83|661.00|771.17|881.33|991.50|1101.67|1211.83|1322.00|1432.17|1542.33|1652.50|1|2|1322.00|2|2| |410',
  },
  ], // FS320.08(4)l
}, {
  cName: 'AGRICULTURAL Trucks/Truck-Tractors, restricted by usage, by Gross Vehicle Weight',
  oSubMenu: [{
    cName: '102 Agricultural Truck/Truck-Tractor under 10,000 lbs GVW',
    cReturn: '102 Agricultural Truck/Truck-Tractor under 10,000 lbs GVW|7.31|14.63|21.94|29.25|36.56|43.88|51.19|58.50|65.81|73.13|80.44|87.75|95.06|102.38|109.69|1|2|87.75|2|2| |102',
  }, // 102//monthly//FS320.08(4)n
  {
    cName: '102 Agricultural Truck/Truck-Tractor 10,000b thru 43,999 lbs GVW',
    cReturn: '102 Agricultural Truck/Truck-Tractor 10,000 thru 43,999 lbs GVW|7.31|14.63|21.94|29.25|36.56|43.88|51.19|58.50|65.81|73.13|80.44|87.75|95.06|102.38|109.69|1|2|87.75|2|2| |1020',
  }, // 102//monthly//FS320.08(4)n
  {
    cName: '102 Agricultural Truck/Truck-Tractor 44000 to 80,000 lbs GVW',
    cReturn: '102 Agricultural Truck/Truck-Tractor 44000 to 80,000 lbs GVW|27.00|54.00|81.00|108.00|135.00|162.00|189.00|216.00|243.00|270.00|297.00|324.00|351.00|378.00|405.00|1|2|324.00|2|2| |1020',
  }, // FS320.08(4)n
  {
    cName: '93 Agricultural vehicle, Goats, all',
    // this was the NEW value:
    // cReturn: "93 Agricultural vehicle, Goats, all|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.63|6.25|6.88|7.50|8.13|8.75|9.38|1|19.10|7.50|2|2| |93"
    // but we are using the OLD value, because Goats are not suposed to be eligable for 2ndYear fee?
    cReturn: '93 Agricultural vehicle, Goats, all|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.63|6.25|6.88|7.50|8.13|8.75|9.38|1|2|7.50|2|2| |93',
  }, // FS320.08(3)d
  {
    cName: '39 Forestry Truck/Truck-Tractor under 10,000 GVW',
    cReturn: '39 Forestry Truck/Truck-Tractor under 10,000 GVW, restricted use|27.00|54.00|81.00|108.00|135.00|162.00|189.00|216.00|243.00|270.00|297.00|324.00|351.00|378.00|405.00|1|2|324.00|2|2| |39',
  }, // FS320.08(4)m
  {
    cName: '39 Forestry Truck/Truck-Tractor 10,000 and up GVW',
    cReturn: '39 Forestry Truck/Truck-Tractor 10,000 and up GVW, restricted usage|27.00|54.00|81.00|108.00|135.00|162.00|189.00|216.00|243.00|270.00|297.00|324.00|351.00|378.00|405.00|1|2|324.00|2|2| |390',
  },
  ],
},  // FS320.08(4)m
{
  cName: 'WRECKERS, NOT restricted by usage, by Gross Vehicle Weight',
  oSubMenu: [{
    cName: '41 Wrecker, Unrestricted, 10,000 to 14,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 10,000 to 14,999 lbs GVW|9.83|19.67|29.50|39.33|49.17|59.00|68.83|78.67|88.50|98.33|108.17|118.00|127.83|137.67|147.50|1|2|118.00|2|2| |410',
  }, // FS320.08(5)e1
  {
    cName: '41 Wrecker, Unrestricted, 15,000 to 19,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 15,000 to 19,999 lbs GVW|14.75|29.50|44.25|59.00|73.75|88.50|103.25|118.00|132.75|147.50|162.25|177.00|191.75|206.50|221.25|1|2|177.00|2|2| |410',
  }, // FS320.08(5)e2
  {
    cName: '41 Wrecker, Unrestricted, 20,000 to 25,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 20,000 to 25,999 lbs GVW|20.92|41.83|62.75|83.67|104.58|125.50|146.42|167.33|188.25|209.17|230.08|251.00|271.92|292.83|313.75|1|2|251.00|2|2| |410',
  }, // FS320.08(5)e3
  {
    cName: '41 Wrecker, Unrestricted, 26,000 to 34,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 26,000 to 34,999 lbs GVW|27.00|54.00|81.00|108.00|135.00|162.00|189.00|216.00|243.00|270.00|297.00|324.00|351.00|378.00|405.00|1|2|324.00|2|2| |410',
  }, // FS320.08(5)e4
  {
    cName: '41 Wrecker, Unrestricted, 35,000 to 43,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 35,000 to 43,999 lbs GVW|33.75|67.50|101.25|135.00|168.75|202.50|236.25|270.00|303.75|337.50|371.25|405.00|438.75|472.50|506.25|1|2|405.00|2|2| |410',
  }, // FS320.08(5)e5
  {
    cName: '41 Wrecker, Unrestricted, 44,000 to 54,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 44,000 to 54,999 lbs GVW|64.33|128.67|193.00|257.33|321.67|386.00|450.33|514.67|579.00|643.33|707.67|772.00|836.33|900.67|965.00|1|2|772.00|2|2| |410',
  }, // FS320.08(5)e6
  {
    cName: '41 Wrecker, Unrestricted, 55,000 to 61,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 55,000 to 61,999 lbs GVW|76.25|152.50|228.75|305.00|381.25|457.50|533.75|610.00|686.25|762.50|838.75|915.00|991.25|1067.50|1143.75|1|2|915.00|2|2| |410',
  }, // FS320.08(5)e7
  {
    cName: '41 Wrecker, Unrestricted, 62,000 to 71,999 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 62,000 to 71,999 lbs GVW|90.00|180.00|270.00|360.00|450.00|540.00|630.00|720.00|810.00|900.00|990.00|1080.00|1170.00|1260.00|1350.00|1|2|1080.00|2|2| |410',
  }, // FS320.08(5)e8
  {
    cName: '41 Wrecker, Unrestricted, 72,000 to 80,000 lbs GVW',
    cReturn: '41 Wrecker, Unrestricted, 72,000 to 80,000 lbs GVW|110.17|220.33|330.50|440.67|550.83|661.00|771.17|881.33|991.50|1101.67|1211.83|1322.00|1432.17|1542.33|1652.50|1|2|1322.00|2|2| |410',
  },
  ], // FS320.08(5)e9
}];

module.exports = heavyTrucks;
